// @ts-nocheck
import * as Types from '../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type InternalConfigurationsLandingPageQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.CheckoutConfigsFilter>;
  page?: Types.InputMaybe<Types.PageFilter>;
  order?: Types.InputMaybe<Types.CheckoutConfigsOrder>;
}>;


export type InternalConfigurationsLandingPageQuery = { __typename?: 'Query', checkoutConfigs: { __typename?: 'CheckoutConfigsPage', entities: Array<{ __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, status: Types.CheckoutConfigStatus, createdAt: Types.Scalars['DateTime']['input'], expiresAt?: Types.Scalars['Date']['input'] | null | undefined, reservedAt?: Types.Scalars['DateTime']['input'] | null | undefined, customerEmail?: string | null | undefined, customerFirstName?: string | null | undefined, customerLastName?: string | null | undefined, customerPhone?: string | null | undefined, createdBy?: { __typename?: 'User', id: string, name: string } | null | undefined, community: { __typename?: 'Community', id: string, name: string }, checkoutUrl: { __typename?: 'Url', path: string }, structure: { __typename?: 'Structure', id: string, name: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type InternalConfigurationsLandingPage_AuthorizedUsersQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.HomeownersFilter>;
  page?: Types.InputMaybe<Types.PageFilter>;
  order?: Types.InputMaybe<Types.HomeownersOrder>;
}>;


export type InternalConfigurationsLandingPage_AuthorizedUsersQuery = { __typename?: 'Query', homeowners: { __typename?: 'HomeownersPage', entities: Array<{ __typename?: 'Homeowner', id: string, firstName: string, lastName: string, email: string, phone?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], canViewCheckout: boolean, createdBy?: { __typename?: 'User', id: string, name: string } | null | undefined }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type InternalConfigurationsLandingPage_SaveHomeownerMutationVariables = Types.Exact<{
  input: Types.SaveHomeownerInput;
}>;


export type InternalConfigurationsLandingPage_SaveHomeownerMutation = { __typename?: 'Mutation', saveHomeowner: { __typename?: 'SaveHomeownerResult', homeowner: { __typename?: 'Homeowner', id: string, canViewCheckout: boolean } } };

export type InternalConfigurationsLandingPage_ArchiveCheckoutConfigMutationVariables = Types.Exact<{
  input: Types.SaveCheckoutConfigInput;
}>;


export type InternalConfigurationsLandingPage_ArchiveCheckoutConfigMutation = { __typename?: 'Mutation', saveCheckoutConfig: { __typename?: 'SaveCheckoutConfigResult', checkoutConfig: { __typename?: 'CheckoutConfig', id: string } } };

export type InternalConfigurationsLandingPage_UnReserveCheckoutConfigMutationVariables = Types.Exact<{
  input: Types.UnreserveCheckoutConfigInput;
}>;


export type InternalConfigurationsLandingPage_UnReserveCheckoutConfigMutation = { __typename?: 'Mutation', unreserveCheckoutConfig: { __typename?: 'SaveCheckoutConfigResult', checkoutConfig: { __typename?: 'CheckoutConfig', id: string } } };

export type InternalConfigurationsLandingPage_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, status: Types.CheckoutConfigStatus, createdAt: Types.Scalars['DateTime']['input'], expiresAt?: Types.Scalars['Date']['input'] | null | undefined, reservedAt?: Types.Scalars['DateTime']['input'] | null | undefined, customerEmail?: string | null | undefined, customerFirstName?: string | null | undefined, customerLastName?: string | null | undefined, customerPhone?: string | null | undefined, createdBy?: { __typename?: 'User', id: string, name: string } | null | undefined, community: { __typename?: 'Community', id: string, name: string }, checkoutUrl: { __typename?: 'Url', path: string }, structure: { __typename?: 'Structure', id: string, name: string } };

export type InternalConfigurationsLandingPage_HomeownerFragment = { __typename?: 'Homeowner', id: string, firstName: string, lastName: string, email: string, phone?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], canViewCheckout: boolean, createdBy?: { __typename?: 'User', id: string, name: string } | null | undefined };

export const InternalConfigurationsLandingPage_CheckoutConfigFragmentDoc = gql`
    fragment InternalConfigurationsLandingPage_CheckoutConfig on CheckoutConfig {
  id
  name
  status
  createdAt
  expiresAt
  reservedAt
  customerEmail
  customerFirstName
  customerLastName
  customerPhone
  createdBy {
    id
    name
  }
  community {
    id
    name
  }
  checkoutUrl {
    path
  }
  structure {
    id
    name
  }
}
    `;
export const InternalConfigurationsLandingPage_HomeownerFragmentDoc = gql`
    fragment InternalConfigurationsLandingPage_Homeowner on Homeowner {
  id
  firstName
  lastName
  email
  phone
  createdAt
  createdBy {
    id
    name
  }
  canViewCheckout
}
    `;
export const InternalConfigurationsLandingPageDocument = gql`
    query InternalConfigurationsLandingPage($filter: CheckoutConfigsFilter, $page: PageFilter, $order: CheckoutConfigsOrder) {
  checkoutConfigs(filter: $filter, page: $page, order: $order) {
    entities {
      ...InternalConfigurationsLandingPage_CheckoutConfig
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${InternalConfigurationsLandingPage_CheckoutConfigFragmentDoc}`;

/**
 * __useInternalConfigurationsLandingPageQuery__
 *
 * To run a query within a React component, call `useInternalConfigurationsLandingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalConfigurationsLandingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalConfigurationsLandingPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInternalConfigurationsLandingPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InternalConfigurationsLandingPageQuery, InternalConfigurationsLandingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InternalConfigurationsLandingPageQuery, InternalConfigurationsLandingPageQueryVariables>(InternalConfigurationsLandingPageDocument, options);
      }
export function useInternalConfigurationsLandingPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InternalConfigurationsLandingPageQuery, InternalConfigurationsLandingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InternalConfigurationsLandingPageQuery, InternalConfigurationsLandingPageQueryVariables>(InternalConfigurationsLandingPageDocument, options);
        }
export type InternalConfigurationsLandingPageQueryHookResult = ReturnType<typeof useInternalConfigurationsLandingPageQuery>;
export type InternalConfigurationsLandingPageLazyQueryHookResult = ReturnType<typeof useInternalConfigurationsLandingPageLazyQuery>;
export type InternalConfigurationsLandingPageQueryResult = Apollo.QueryResult<InternalConfigurationsLandingPageQuery, InternalConfigurationsLandingPageQueryVariables>;
export const InternalConfigurationsLandingPage_AuthorizedUsersDocument = gql`
    query InternalConfigurationsLandingPage_AuthorizedUsers($filter: HomeownersFilter, $page: PageFilter, $order: HomeownersOrder) {
  homeowners(filter: $filter, page: $page, order: $order) {
    entities {
      ...InternalConfigurationsLandingPage_Homeowner
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${InternalConfigurationsLandingPage_HomeownerFragmentDoc}`;

/**
 * __useInternalConfigurationsLandingPage_AuthorizedUsersQuery__
 *
 * To run a query within a React component, call `useInternalConfigurationsLandingPage_AuthorizedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalConfigurationsLandingPage_AuthorizedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalConfigurationsLandingPage_AuthorizedUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInternalConfigurationsLandingPage_AuthorizedUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InternalConfigurationsLandingPage_AuthorizedUsersQuery, InternalConfigurationsLandingPage_AuthorizedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InternalConfigurationsLandingPage_AuthorizedUsersQuery, InternalConfigurationsLandingPage_AuthorizedUsersQueryVariables>(InternalConfigurationsLandingPage_AuthorizedUsersDocument, options);
      }
export function useInternalConfigurationsLandingPage_AuthorizedUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InternalConfigurationsLandingPage_AuthorizedUsersQuery, InternalConfigurationsLandingPage_AuthorizedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InternalConfigurationsLandingPage_AuthorizedUsersQuery, InternalConfigurationsLandingPage_AuthorizedUsersQueryVariables>(InternalConfigurationsLandingPage_AuthorizedUsersDocument, options);
        }
export type InternalConfigurationsLandingPage_AuthorizedUsersQueryHookResult = ReturnType<typeof useInternalConfigurationsLandingPage_AuthorizedUsersQuery>;
export type InternalConfigurationsLandingPage_AuthorizedUsersLazyQueryHookResult = ReturnType<typeof useInternalConfigurationsLandingPage_AuthorizedUsersLazyQuery>;
export type InternalConfigurationsLandingPage_AuthorizedUsersQueryResult = Apollo.QueryResult<InternalConfigurationsLandingPage_AuthorizedUsersQuery, InternalConfigurationsLandingPage_AuthorizedUsersQueryVariables>;
export const InternalConfigurationsLandingPage_SaveHomeownerDocument = gql`
    mutation InternalConfigurationsLandingPage_SaveHomeowner($input: SaveHomeownerInput!) {
  saveHomeowner(input: $input) {
    homeowner {
      id
      canViewCheckout
    }
  }
}
    `;
export type InternalConfigurationsLandingPage_SaveHomeownerMutationFn = Apollo.MutationFunction<InternalConfigurationsLandingPage_SaveHomeownerMutation, InternalConfigurationsLandingPage_SaveHomeownerMutationVariables>;

/**
 * __useInternalConfigurationsLandingPage_SaveHomeownerMutation__
 *
 * To run a mutation, you first call `useInternalConfigurationsLandingPage_SaveHomeownerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInternalConfigurationsLandingPage_SaveHomeownerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [internalConfigurationsLandingPageSaveHomeownerMutation, { data, loading, error }] = useInternalConfigurationsLandingPage_SaveHomeownerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalConfigurationsLandingPage_SaveHomeownerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InternalConfigurationsLandingPage_SaveHomeownerMutation, InternalConfigurationsLandingPage_SaveHomeownerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InternalConfigurationsLandingPage_SaveHomeownerMutation, InternalConfigurationsLandingPage_SaveHomeownerMutationVariables>(InternalConfigurationsLandingPage_SaveHomeownerDocument, options);
      }
export type InternalConfigurationsLandingPage_SaveHomeownerMutationHookResult = ReturnType<typeof useInternalConfigurationsLandingPage_SaveHomeownerMutation>;
export type InternalConfigurationsLandingPage_SaveHomeownerMutationResult = Apollo.MutationResult<InternalConfigurationsLandingPage_SaveHomeownerMutation>;
export type InternalConfigurationsLandingPage_SaveHomeownerMutationOptions = Apollo.BaseMutationOptions<InternalConfigurationsLandingPage_SaveHomeownerMutation, InternalConfigurationsLandingPage_SaveHomeownerMutationVariables>;
export const InternalConfigurationsLandingPage_ArchiveCheckoutConfigDocument = gql`
    mutation InternalConfigurationsLandingPage_ArchiveCheckoutConfig($input: SaveCheckoutConfigInput!) {
  saveCheckoutConfig(input: $input) {
    checkoutConfig {
      id
    }
  }
}
    `;
export type InternalConfigurationsLandingPage_ArchiveCheckoutConfigMutationFn = Apollo.MutationFunction<InternalConfigurationsLandingPage_ArchiveCheckoutConfigMutation, InternalConfigurationsLandingPage_ArchiveCheckoutConfigMutationVariables>;

/**
 * __useInternalConfigurationsLandingPage_ArchiveCheckoutConfigMutation__
 *
 * To run a mutation, you first call `useInternalConfigurationsLandingPage_ArchiveCheckoutConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInternalConfigurationsLandingPage_ArchiveCheckoutConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [internalConfigurationsLandingPageArchiveCheckoutConfigMutation, { data, loading, error }] = useInternalConfigurationsLandingPage_ArchiveCheckoutConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalConfigurationsLandingPage_ArchiveCheckoutConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InternalConfigurationsLandingPage_ArchiveCheckoutConfigMutation, InternalConfigurationsLandingPage_ArchiveCheckoutConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InternalConfigurationsLandingPage_ArchiveCheckoutConfigMutation, InternalConfigurationsLandingPage_ArchiveCheckoutConfigMutationVariables>(InternalConfigurationsLandingPage_ArchiveCheckoutConfigDocument, options);
      }
export type InternalConfigurationsLandingPage_ArchiveCheckoutConfigMutationHookResult = ReturnType<typeof useInternalConfigurationsLandingPage_ArchiveCheckoutConfigMutation>;
export type InternalConfigurationsLandingPage_ArchiveCheckoutConfigMutationResult = Apollo.MutationResult<InternalConfigurationsLandingPage_ArchiveCheckoutConfigMutation>;
export type InternalConfigurationsLandingPage_ArchiveCheckoutConfigMutationOptions = Apollo.BaseMutationOptions<InternalConfigurationsLandingPage_ArchiveCheckoutConfigMutation, InternalConfigurationsLandingPage_ArchiveCheckoutConfigMutationVariables>;
export const InternalConfigurationsLandingPage_UnReserveCheckoutConfigDocument = gql`
    mutation InternalConfigurationsLandingPage_UnReserveCheckoutConfig($input: UnreserveCheckoutConfigInput!) {
  unreserveCheckoutConfig(input: $input) {
    checkoutConfig {
      id
    }
  }
}
    `;
export type InternalConfigurationsLandingPage_UnReserveCheckoutConfigMutationFn = Apollo.MutationFunction<InternalConfigurationsLandingPage_UnReserveCheckoutConfigMutation, InternalConfigurationsLandingPage_UnReserveCheckoutConfigMutationVariables>;

/**
 * __useInternalConfigurationsLandingPage_UnReserveCheckoutConfigMutation__
 *
 * To run a mutation, you first call `useInternalConfigurationsLandingPage_UnReserveCheckoutConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInternalConfigurationsLandingPage_UnReserveCheckoutConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [internalConfigurationsLandingPageUnReserveCheckoutConfigMutation, { data, loading, error }] = useInternalConfigurationsLandingPage_UnReserveCheckoutConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalConfigurationsLandingPage_UnReserveCheckoutConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InternalConfigurationsLandingPage_UnReserveCheckoutConfigMutation, InternalConfigurationsLandingPage_UnReserveCheckoutConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InternalConfigurationsLandingPage_UnReserveCheckoutConfigMutation, InternalConfigurationsLandingPage_UnReserveCheckoutConfigMutationVariables>(InternalConfigurationsLandingPage_UnReserveCheckoutConfigDocument, options);
      }
export type InternalConfigurationsLandingPage_UnReserveCheckoutConfigMutationHookResult = ReturnType<typeof useInternalConfigurationsLandingPage_UnReserveCheckoutConfigMutation>;
export type InternalConfigurationsLandingPage_UnReserveCheckoutConfigMutationResult = Apollo.MutationResult<InternalConfigurationsLandingPage_UnReserveCheckoutConfigMutation>;
export type InternalConfigurationsLandingPage_UnReserveCheckoutConfigMutationOptions = Apollo.BaseMutationOptions<InternalConfigurationsLandingPage_UnReserveCheckoutConfigMutation, InternalConfigurationsLandingPage_UnReserveCheckoutConfigMutationVariables>;